// Single source of truth for the height of the bottom-nav strip. Imported by
// the nav itself, its selection-mode replacement (bulk-action-bar), and the
// project layout, which publishes the strip's current height as a CSS custom
// property (below) for everything that anchors above it.
//
// See specs/conventions/safe-area-bottom.md § "The one-owner rule".
export const NAV_HEIGHT_PX = 72;

// Width of the navigation rail that replaces the bottom nav from 768px.
// See [[bottom-nav.spec]] § Layout.
export const RAIL_WIDTH_PX = 80;

/**
 * What runs along the bottom of the project shell right now: the phone's nav or
 * the bulk action bar (72px), or nothing (0px — a phone's nested screen, or a
 * wide screen, where the nav is the rail). Set by the project layout; read by
 * `<main>`, FABs and bottom bars. See [[safe-area-bottom]] § The bottom strip.
 */
export const BOTTOM_STRIP_VAR = "--bottom-strip-height";

/** The rail's width where it is shown, else 0px. Set by the project layout. */
export const RAIL_WIDTH_VAR = "--nav-rail-width";

/**
 * `bottom` for something anchored `gapPx` above the bottom strip. Outside the
 * project shell the property is unset and this falls back to the phone nav's
 * 72px, so a caller there keeps today's position. A caller that also lives on a
 * screen with no strip at all (the projects home) passes `fallbackPx: 0`.
 */
export function aboveBottomStrip(
  gapPx: number,
  fallbackPx: number = NAV_HEIGHT_PX,
): string {
  return `calc(var(${BOTTOM_STRIP_VAR}, ${fallbackPx}px) + ${gapPx}px + env(safe-area-inset-bottom, 0px))`;
}
